import { Injectable } from '@angular/core';
import { getQuoteStepsNavigationBarItems } from '../../utils';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';
import { AvailableStepsInNavigationBar, NavigationBarItem, RouteIds, Step } from '../../types';
import { BaseStepDefinitionStrategy } from './base-step-definition.strategy';
import { StepDefinitionStrategy } from './step-definition.strategy';
import { Flows, Flow } from '@lx/quote-tool/lite/shared/types';

@Injectable({
  providedIn: 'root',
})
export class AyaQuoteStepDefinitionService extends BaseStepDefinitionStrategy implements StepDefinitionStrategy {
  private stepDefinition: Step = {
    id: RouteIds.ayaQuote,
    title: $localize`We have received your enquiry`,
    subtitles: [
      $localize`One of our dedicated student advisors will be in touch to help align your Kaplan experience with your goals.
`,
      $localize`In the meantime learn more about your program:`,
    ],
    googleAnalyticsEvent: GoogleAnalyticsEventEnum.Quote,
  };

  getStepDefinition(activeFlow: Flow) {
    return {
      ...this.stepDefinition,
      navigationBarItems: this.getNavigationBarItems(activeFlow),
    };
  }

  fillNavigationBarItemsProperties(
    baseNavigationBarItems: Record<AvailableStepsInNavigationBar, NavigationBarItem>,
  ): Record<AvailableStepsInNavigationBar, NavigationBarItem> {
    return getQuoteStepsNavigationBarItems(Flows.Aya, baseNavigationBarItems);
  }
}
